function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ffffff;stroke-linecap:round;stroke-linejoin:round;stroke-width:11px;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M170.07,198.1c-3.93,1.8-10.53,5.53-18.62,5.56-8.28,0-14.65-3.74-18.62-5.56,1.09-1.43,2.17-2.88,3.25-4.31a10.18,10.18,0,0,1,5.09-3.7,8.92,8.92,0,0,1,2.05-.37c4.08-.32,5,1.28,8.32,1.33s4.22-1.58,8.31-1.18a9,9,0,0,1,2.55.59,10.33,10.33,0,0,1,4.35,3.34Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M162.16,166c-.29,1.22-1.2,1.48-4.75,4s-9.85,2.45-13.33,0-4.46-2.73-4.74-4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M90.22,128.77a9.06,9.06,0,0,1,11.13.06,21.56,21.56,0,0,0,9.27,4.74,22.38,22.38,0,0,0,7.3.39c1.67-.15,2.93-.43,9.61-2.31,2.27-.63,4.17-1.18,5.56-1.58"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M101.88,137.64c1.41-3.6,5.7-4.43,6.83-4.61"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M210.77,128.77a9.06,9.06,0,0,0-11.13.06,21.56,21.56,0,0,1-9.27,4.74,22.38,22.38,0,0,1-7.3.39c-1.67-.15-2.93-.43-9.61-2.31-2.27-.63-4.17-1.18-5.56-1.58"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M192.28,133c1.13.18,5.42,1,6.83,4.61"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M78.41,178A215.28,215.28,0,0,1,71,120.32,149.44,149.44,0,0,1,81.28,97.26c5.3-9.63,14.94-26.74,34.05-41.15a111.69,111.69,0,0,1,22.93-13.3"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M223.43,177.46a213.21,213.21,0,0,0,6.33-57.38c-1.09-2.55-2.7-6.24-4.79-10.63-17.39-36.59-45-65.68-83.74-79.35"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M132.83,107.93s-4.23-5.65-14.12-7.53-22.13,0-22.13,0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M163,107.83s4.24-5.65,14.13-7.54,22.12,0,22.12,0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M91.4,234.66c-2.32-5.15-4.64-10.3-6.9-15.45L66.9,193a11.91,11.91,0,0,1,15.62-.73c2.49,2,4.75,2.94,15,14.54,1.7,1.92,3.17,3.62,4.53,5.14,1.07,1.19,1.87,2.1,1.92,2.21,4.41,5,16.58,16.35,16.58,16.35,10.86,10.18,16.4,15.33,17.59,23,.51,3.05.68,8.76-3.85,16.46"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M60.79,183.91,57,175.15l-1.86-5.72v-21.1c.56-5.26,2.71-12.1,1-15.89a11.66,11.66,0,0,0-5.77-6.06c-1.25-.56-2.32-.73-2.38.29l-7.86,43.16c-.57,5.65.62,20.08,1.47,29a23,23,0,0,0,5.49,12.84C55,224,84.67,261.92,92.36,269.9"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M165.62,269.9c-4.47-7.7-4.3-13.41-3.85-16.46,1.24-7.64,6.73-12.79,17.65-23,0,0,12.16-11.37,16.57-16.35.06-.11.85-1,1.93-2.21,1.3-1.52,2.82-3.22,4.46-5.14,10.3-11.6,12.62-12.56,15.05-14.54A11.89,11.89,0,0,1,233,193l-17.53,26.25c-2.32,5.15-4.58,10.3-6.9,15.45"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M207.59,269.9c7.69-8,37.39-45.88,45.31-58.27a23,23,0,0,0,5.43-12.84c.85-8.88,2.09-23.31,1.53-29L252,126.67c-.11-1-1.13-.85-2.37-.29a11.73,11.73,0,0,0-5.83,6.06c-1.64,3.79.51,10.63,1.08,15.89v21.1L243,175.15l-3.85,8.76"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M138.39,250.36a24.29,24.29,0,0,0,23.77,0"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M71,120.32S55.78,99.43,54.65,87.93"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M230,120.32s15.24-20.89,16.37-32.39"
});

function SvgIconMySkinProfileWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMySkinProfileWhite);
export default __webpack_public_path__ + "static/media/icon-my-skin-profile-white.6fabd960.svg";
export { ForwardRef as ReactComponent };